import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditStorageSpacePageNew from "../../components/StorageSpace/EditStorageSpace";



const EditStorageSpace = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Storage Space" link2="/storage-space" title="Edit Storage Space" />

        {/* AddUserLayer */}
        <EditStorageSpacePageNew />


      </MasterLayout>
    </>
  );
};

export default EditStorageSpace;
